import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e0c060ba")

_pushScopeId("data-v-e0c060ba")
const _hoisted_1 = { class: "insurance-bar" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "insurance-bar__header" }, "Ik heb een:", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CheckBox = _resolveComponent("CheckBox")
  const _component_InsuranceInfo = _resolveComponent("InsuranceInfo")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("span", null, [
      _createVNode(_component_CheckBox, {
        modelValue: _ctx.state.insurance.hasWIAEmployee,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.state.insurance.hasWIAEmployee = $event)),
        inline: "",
        label: "WIA-werknemersverzekering"
      }, null, 8, ["modelValue"])
    ]),
    (_ctx.exceedsUwvMax)
      ? (_openBlock(), _createBlock("span", _hoisted_3, [
          _createVNode(_component_CheckBox, {
            modelValue: _ctx.state.insurance.hasWIAExcedent,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.state.insurance.hasWIAExcedent = $event)),
            inline: "",
            label: "WIA-excedentverzekering"
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.exceedsExcedentMax)
      ? (_openBlock(), _createBlock("span", _hoisted_4, [
          _createVNode(_component_CheckBox, {
            modelValue: _ctx.state.insurance.hasWIAExcedentTop,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.state.insurance.hasWIAExcedentTop = $event)),
            inline: "",
            label: "WIA-excedentverzekering Top"
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_InsuranceInfo)
  ]))
})